<template>
  <div id="app">
    <!--    <img src="./assets/logo.png">-->
    <router-view style="-moz-user-select:none; user-select: none"></router-view>
  </div>
</template>

<script>
export default {
  name:'App',
  // components: {Login},

  methods:{
    /*方法*/
  },
  mounted() { /*页面加载时调用*/
    document.title = "管理平台";
    document.getElementsByTagName("body")[0].style = "overflow: hidden;"; /*去除滚动条*/
  }
};
</script>

<style>
html, body, #app {
  height: 100vh;
  margin: 0 0 auto;
  padding: 0;
  /*background: url("assets/login.jpg");
    background-size: 100% 110%;
    height: calc(100vh - 1rem);
    width: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;*/
}

p {
  padding: 0;
  margin: 0;
}

.el-radio-group {
  font-size: 0;
  display: inline-flex; /* 或者 flex */
}

.el-button [class*="el-icon-"] {
  vertical-align: middle;
  position: relative;
  top: 4px;
}

.el-button [class*="el-icon-"] + span {
  vertical-align: middle;
}

.el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue